<template>
  <div class="one" style="margin-top:.10rem">
    <div v-loading="lunboLoading" class="lunboOut" style="flex:1;width:3.43rem;margin:auto;border-radius:10px;overflow:hidden">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" @change="onChange">
        <van-swipe-item v-for="(item,index) in dataList" :key="index" style="border-radius:10px;">
          <div class="lunbo" style="border-radius:10px;" @click="$go(item.linkUrl)">
            <img class="lunboImg" :src="$beforeUrl(item.img)">
          </div>
        </van-swipe-item>
        <template #indicator>
          <div class="custom-indicator oneLine">{{ dataList[current].imgName }}</div>
        </template>
      </van-swipe>

    </div>

  </div>
</template>

<script>
import { Swipe, SwipeItem } from 'vant'
export default {
  components: {
    'van-swipe-item': SwipeItem,
    'van-swipe': Swipe
  },
  data() {
    return {
      dataList: [
      ],
      lunboLoading: true,
      current: 0
    }
  },

  mounted() {

  },
  created() {
    this.getInfo()
  },

  methods: {
    getInfo() {
      const top = 10
      const position = 'banner'
      const tempId = this.$store.getters.module
      this.$store.dispatch('home/HomeGetSiteAd', { top, position, tempId }).then(res => {
        if (res.code === 0 && res.data[0] && res.data[0].jsonText) {
          this.dataList = JSON.parse(res.data[0].jsonText)
        }
        this.lunboLoading = false
      })
    },
    onChange(index) {
      this.current = index
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep{
  .van-swipe__indicator{
    background: var(--theme)!important;

  }
  .van-swipe__track{
    height: 2.28rem!important;
  }
}
  .lunboImg{
    width: 3.43rem;
    height: 2.28rem;
    border-radius:10px;
  }
  .lunbo{
    overflow: hidden!important;
  }
 .custom-indicator {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: .4rem;
    background-image: linear-gradient(to bottom,rgba(255,255,255,.5),rgba(0,0,0,.85) 90%);
    font-size: .17rem;
    font-weight: bold;
    color: #FFFFFF;
    line-height: .4rem;
    padding: 0 .13rem;
  }
</style>
